<template>
  <div class="app" v-bind:class="getSidebar">
    <AppHeader :navItems="nav" />
    <div class="app-body">
      <!-- <Sidebar :navItems="nav"/> -->
      <main class="main">
        <!-- <breadcrumb :list="list"/> -->
        <div class="container-fluid px5 py5 h-100">
          <router-view></router-view>
        </div>
      </main>
      <AppAside />
    </div>
  </div>
</template>

<script>
import nav from "../_nav";
// import moment from 'moment'
import { mapGetters, mapMutations } from "vuex";
import {
  Header as AppHeader,
  Sidebar,
  Aside as AppAside,
} from "../components/";
var Stomp = require("stompjs");

export default {
  name: "full",
  components: {
    AppHeader,
    Sidebar,
    AppAside,
  },
  data() {
    return {
      nav: nav.items,
      alarmTimer: null,
      msgBoxOpen: false,
      popupShow: false,
    };
  },
  computed: {
    ...mapGetters([
      "getSidebar",
      "getAlertOptions",
      "getWindowHeight",
      "getWindowWidth",
      "getCenterBus",
      "getUserInfo",
    ]),
  },
  created() {
    window.addEventListener("resize", this.resizeEvent);
    window.addEventListener("beforeunload", this.reloadEvent);
    this.setWindowWidth(window.innerWidth);
    this.setWindowHeight(window.innerHeight);
  },
  mounted() {
    // this.startMonitoring()
    window.addEventListener("keydown", this.handelKeyDown);
  },
  destroyed() {
    // this.stopMonitoring()
    window.removeEventListener("keydown", this.handelKeyDown);
    window.removeEventListener("resize", this.resizeEvent);
    window.removeEventListener("beforeunload", this.reloadEvent);
  },
  methods: {
    ...mapMutations(["setAlertTitle", "setWindowHeight", "setWindowWidth"]),
    handelKeyDown(event) {
      if (event.key === "Enter") {
        const modal = document.getElementById("confirmBModal");
        if (modal && modal.classList.contains("show")) {
          const confirmButton = modal.querySelector(
            ".modal-footer .btn-primary"
          );
          if (confirmButton) {
            confirmButton.click();
          }
        }

        const alertModal = document.getElementById("alertBModal");
        if (alertModal && alertModal.classList.contains("show")) {
          const alertButton = alertModal.querySelector(
            ".modal-footer .btn-primary"
          );
          if (alertButton) {
            alertButton.click();
          }
        }
      } else if (event.key === "Escape") {
        const modalDialog = document.querySelectorAll(".modal-dialog");
        const lastModalDialog = modalDialog[modalDialog.length - 1];
        if (lastModalDialog) {
          const deleteButton = lastModalDialog.querySelector(".empty-delBtn");
          if (deleteButton) {
            deleteButton.click();
          }
        }
      }
    },
    resizeEvent(evt) {
      this.setWindowWidth(evt.currentTarget.innerWidth);
      this.setWindowHeight(evt.currentTarget.innerHeight);
      this.getCenterBus.$emit("resizeEvent");
    },
    reloadEvent(evt) {
      localStorage.setItem("userInfo", JSON.stringify(this.getUserInfo));
      this.setWindowWidth(evt.currentTarget.innerWidth);
      this.setWindowHeight(evt.currentTarget.innerHeight);
      this.getCenterBus.$emit("reloadEvent");
    },
    startMonitoring() {
      if (this.alarmTimer === null) {
        this.alarmTimer = setInterval(() => {
          // this.showCount()
        }, 5000);
      }
    },
    stopMonitoring() {
      if (this.alarmTimer !== null) {
        clearInterval(this.alarmTimer);
        this.alarmTimer = null;
      }
    },
  },
};
</script>

<style>
.header-fixed .app-body {
  margin-left: auto;
  margin-right: auto;
  margin-top: 80px !important;
  width: 100%;
  overflow: auto;
  height: calc(100vh - 80px);
}
body {
  background-color: #fff;
}
.main {
  height: 100%;
  min-height: 600px;
}
.container-fluid {
  min-width: 1000px;
  width: 100%;
  /* overflow-y: auto; */
}
</style>



// WEBPACK FOOTER //
// src/containers/Full.vue